module.exports = __webpack_public_path__ + "img/burger.37123bd7.svg";